<template>
  <div class="home" id="homeview">
      <b-row style="margin: auto">
      <b-col cols="3">    
        <TMLinks />
      </b-col>
    <b-col cols=9>
    <b-tabs content-class="mt-3">
      <b-tab title="General Info"  active>
        <ThermoML />
      </b-tab>
      <b-tab title="Data Summary">
        <Summary />
      </b-tab>
      <b-tab title="Searching Info">
        <APInfo />
      </b-tab>
    </b-tabs>
    </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import TMLinks from '@/components/TMLinks.vue'
import ThermoML from '@/components/ThermoML.vue'
import Summary from '@/components/Summary.vue'
import APInfo from '@/components/APInfo.vue'

export default {
  name: 'TmlHome',
  components: {
    TMLinks,
    ThermoML,
    Summary,
    APInfo
  }
}
</script>
<style lang="scss">
#homeview {

  a {
    color: #11263d;
  }
}
</style>